import EvaluationLeaves from './EvaluationLeaf/EvaluationLeaves.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const SigatokaRouters = {
  path: 'diseases',
  name: 'leaf.evaluation_leaves',
  component: MasterTab,
  props: { reference: 'sigatokaTabs' },
  children: [
    {
      path: 'evaluationleaves',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'leaf.evaluation_leaves',
          component: EvaluationLeaves,
          meta: {
            prefix_permission: 'evaluation_leaves',
          },
        },
      ],
    },
  ],
};

export default SigatokaRouters;
